import { gql } from '@apollo/client';

export const CANCEL_PAYMENT = gql`
  mutation CANCEL_PAYMENT($registrationId: String!) {
      cancelPayment(registrationId: $registrationId)
  }
`;
